import { gsap } from "@theme/gsap";
import ScrollTrigger from "@theme/gsap/ScrollTrigger";
import { debounce } from '@theme/utilities';



class VerticalScrollSlider extends HTMLElement {
  constructor() {
    super();

    this.mm = window.matchMedia("(min-width: 750px)");
    this.tl = null;
    this.onMediaChange = this.onMediaChange.bind(this);
    this.refresh = this.refresh.bind(this);
    this.onResize = debounce(this.refresh, 500);
  }

  connectedCallback() {
    if (!gsap || !ScrollTrigger) {
      console.warn("GSAP or ScrollTrigger is missing.");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    this.scrollWrapper = this.querySelector(".scroll-wrapper");
    this.horizontalWrapper = this.querySelector(".horizontal-wrapper");
    this.verticalWrapper = this.querySelector(".vertical-wrapper");
    this.sections = [...this.querySelectorAll(".scroll-wrapper .item-horizontal")];

    this.init();
    this.mm.addEventListener("change", this.onMediaChange);

    // Keep it resilient when images/fonts load or viewport changes
    window.addEventListener("resize", this._onResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._onResize);
    this.destroy();
    this.mm.removeEventListener("change", this.onMediaChange);
  }

  onMediaChange() {
    this.init();
  }

  init() {
    this.destroy();

    if (!this.mm.matches) return;
    if (!this.scrollWrapper || !this.horizontalWrapper || !this.verticalWrapper) return;

    const sections = gsap.utils.toArray(
      this.querySelectorAll(".scroll-wrapper .item-vertical")
    );

    if (sections.length <= 1) return;

    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.scrollWrapper,
        pin: true,
        scrub: 1,
        end: `+=${(sections.length - 1) * 1700}`,
        onUpdate: () => this.updateContent()
      }
    });

    this.tl
      // .to(this.horizontalWrapper, {
      //   xPercent: -100 * (sections.length - 1),
      //   ease: "none",
      // }, 0)
      .to(this.verticalWrapper, {
        yPercent: -100 * (sections.length - 1),
        ease: "none",
      }, 0);
  }

  updateContent() {
    const yPercent = gsap.getProperty(this.verticalWrapper, "yPercent");
    const rawIndex = Math.floor((-yPercent + 35) / 100);
    const index = gsap.utils.clamp(0, this.total - 1, rawIndex);
    this.sections.forEach((item, itemIndex) => {
      if (index === itemIndex) {
        item.classList.remove('hidden');
        item.classList.add('flex');
      } else {
        item.classList.remove('flex');
        item.classList.add('hidden');
      }
    })
  }

  destroy() {
    if (this.tl) {
      ScrollTrigger.getById(this.id)?.kill(true);

      this.tl.kill();
      this.tl = null;
    }

    gsap.set([this.horizontalWrapper, this.verticalWrapper], {
      clearProps: "transform"
    });
  }
  refresh() {
    // Avoid rebuild loops if called too early
    if (!this.isConnected) return;
    const y = window.scrollY;

    this.init();
    ScrollTrigger.refresh();

    // window.scrollTo(0, y);
    // ScrollTrigger.refresh();
  }
}

customElements.define("vertical-scroll-slider", VerticalScrollSlider);